<template>
     <div class="wrapper">
        <div class="main-panel">
            <div class="main-content">
                <div class="content-wrapper">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-sm-12">
                            <a class="btn btn-secondary float-right top-back-button" @click.prevent="back()"><i class="fa fa-arrow-left"></i></a>
                            <h2 class="content-header">{{ this.$t("labels.manageLov") }}</h2>
                            </div>
                        </div>
                        <section id="responsive">
                            <div class="row">
                                <div class="col-sm-12">
                                <div class="card collapse-icon accordion-icon-rotate left">
                                    <div class="card-body">
                                        <div class="card-block">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div id="headingCollapse21" class="card-header">
                                                        <a data-toggle="collapse" href="#collapse21" class="lead">{{ $t("labels.newValue") }}</a>
                                                    </div>
                                                    <div id="collapse21" role="tabpanel" class="collapse hide">
                                                        <form class="form">
                                                            <lov-form :lov="lov" :lovTypes="lovTypes" v-on:typechanged="changeFilter" />
                                                            <div class="form-actions">
                                                                <button type="button" class="btn btn-success" @click.prevent="createLov">
                                                                <i class="icon-note"></i> {{ $t("labels.save") }}
                                                                </button>
                                                            </div>
                                                        </form>  
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row bottom-space">
                                                <div class="col-md-3">
                                                    <select class="form-control" @change="getLoves(listType, lovDeleted)" v-model="listType">
                                                        <option v-for="lovType in lovTypes" :value="lovType" :key="lovType">{{ translatedLovType(lovType) }}</option>                        
                                                        
                                                        
                                                    </select>
                                                </div>
                                                <div class="col-md-3">
                                                    <select class="form-control" @change="getLoves(listType, lovDeleted)" v-model="lovDeleted">
                                                        <option value="false">{{ $t("labels.active") }}</option>
                                                        <option value="true">{{ $t("labels.deleted") }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            
                                            <table class="table table-responsive-sm">
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            {{ $t("labels.name") }}
                                                        </th>
                                                        <th>
                                                            {{ $t("labels.type") }}
                                                        </th>
                                                        <th>
                                                            {{ $t("labels.status") }}
                                                        </th>
                                                        <th>
                                                            {{ $t("labels.actions") }}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <draggable 
                                                    style="width: 100%"
                                                    tag="tbody"
                                                    :list="lovs"
                                                    @change="sortAndSave"
                                                    >
                                                        <tr v-for="lov in lovs" :key="lov._id">
                                                            <td>
                                                                <i class="fa fa-bars font-small-3 mr-2"></i>
                                                                {{ lov.name[$i18n.locale] ? lov.name[$i18n.locale] : lov.name['en'] }}
                                                            </td>
                                                            <td>                                                      
                                                            {{ $t(`lovTypes.${lov.type}` )}}</td>
                                                            <td>{{ lov.deleted ? "Deleted" : "Active" }}</td>
                                                            <td>
                                                                <a class="success p-0" @click="setEdited(lov._id)" data-toggle="modal" data-target="#vipModal">
                                                                    <i class="fa fa-pencil font-medium-3 mr-2"></i>
                                                                </a>
                                                                <a class="warning p-0" @click.prevent="deleteValue(lov)" v-if="!lov.deleted">
                                                                    <i class="fa fa-trash font-medium-3 mr-2"></i>
                                                                </a>
                                                                <a class="warning p-0" @click.prevent="activateValue(lov)" v-else>
                                                                    <i class="fa fa-check font-medium-3 mr-2"></i>
                                                                </a>
                                                            </td>
                                                        </tr>
                                                 </draggable>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
        <lov-edit-modal :editedlov="editedLov" v-on:saveedited="updateLov" ref='lovItemModal'></lov-edit-modal>
    </div>
</template>

<script>
import LovForm from '@/components/lov/LovForm.vue'
import LovService from '@/services/lov'
import LovEditModal from '@/components/lov/LovEditModal.vue'
import draggable from 'vuedraggable'

export default {
    components: {
        LovForm,
        LovEditModal,
        draggable
    },
    data() {
        return {
            lovDeleted: false,
            editedLov: {
                type: 'drug',
                name: {}
            },
            listType: 'drug',
            errors: [],
            lovs: [],
            orderedLovs: [],
            lov: {
                type: 'drug',
                name: {}
            },
            lovTypes: ['pathology', 'drug', 'seizure', 'event', 'health_state', 'life_saving_drug', 'medical_exams', 'archive_category', 'triggering_factor', 'duration']
        }
    },
    methods: {
        back() {
          this.$router.push({ name: 'home'})
        },
        sortAndSave: async function() {
            for (let item in this.lovs) {
                this.lovs[item]['position'] = parseInt(item) + 1
            }
            this.lovs.sort(function(a,b){
                return a.position - b.position
            })
            await this.updateLovOrder()
        },
        translatedLovType: function(lovType){      
          return this.$t(`lovTypes.${lovType}`)
        },
        changeFilter: async function() {
            this.listType = this.lov.type
            await this.getLoves(this.listType, false)
        },
        createLov: async function() {
            this.errors = []
            if (!this.lov.name.en || this.lov.name.en.length === 0) {
                this.errors.push(this.$t("errors.nameEnRequired"))
            }
            if (!this.lov.type || this.lov.type.length === 0) {
                this.errors.push(this.$t("errors.typeRequired"))
            }
            if (this.errors.length === 0) {
                let result = await LovService.create(this.lov)
                if (result) {
                    if (result.data.lov.type === this.listType) {
                        await this.getLoves(this.listType, this.lovDeleted)
                    }
                    this.lov = {
                        type: this.listType,
                        name: {}
                    }
                    this.$miniToastr.success(this.$t("flash.createSuccess", [this.$t("models.lov")]))
                } else {
                    this.$miniToastr.error(this.$t("flash.createFailed", [this.$t("models.lov")]))
                }
            } else {
                this.$miniToastr.error(this.$t("flash.createFailed", [this.$t("models.lov")]))
            }
        },
        getLoves: async function(lovType, deleted) {
            let result = await LovService.all(lovType,deleted)
            this.lovs = result.data
            return result
        },
        deleteValue: async function(lov) {
            lov.deleted = true
            let result = await LovService.update(lov)
            if (result.data.lov.type === this.listType) {
                await this.getLoves(this.listType, this.lovDeleted)
            }
        },
        activateValue: async function(lov) {
            lov.deleted = false
            let result = await LovService.update(lov)
            if (result.data.lov.type === this.listType) {
                await this.getLoves(this.listType, this.lovDeleted)
            }
        },
        setEdited(id) {
            let edited = this.lovs.find(lov => lov._id === id)
            this.editedLov = edited
        },
        updateLov: async function() {
            let result = await LovService.update(this.editedLov)
            if (result) {
                this.$miniToastr.success(this.$t("flash.updateSuccess", [this.$t("models.lov")]))
                this.$refs.lovItemModal.$refs.closeLovEditModal.click()
            } else {
                this.$miniToastr.error(this.$t("flash.updateFailed", [this.$t("models.lov")]))
            }
        },
        updateLovOrder: async function() {
            let result = await LovService.updateOrder({'lovs': this.lovs})
            if (result) {
                this.$miniToastr.success(this.$t("flash.updateSuccess", [this.$t("models.lov")]))
                // this.$refs.lovItemModal.$refs.closeLovEditModal.click()
            } else {
                this.$miniToastr.error(this.$t("flash.updateFailed", [this.$t("models.lov")]))
            }
        }
    },
    mounted: async function() {
        await this.getLoves('drug',this.lovDeleted)
    }
}
</script>

<style lang="scss" scoped>
   .card .card-header {
       padding-left: 0 !important;
   }

   .collapse-icon.left a:before, .collapse-icon.left a:after {
       left: 0;
   }
</style>


